function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#827DDC"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E64C3"
    },
    d: "M353.58,190.934l-29.529-29.529c-5.095-5.094-12.013-8.366-19.691-8.752l-37.748-37.748 L93.126,145.343v217.313L242.09,511.62c4.606,0.247,9.242,0.38,13.91,0.38c130.026,0,237.401-96.941,253.816-222.489L401.89,181.584 c-0.001-0.001-0.002-0.002-0.004-0.004l0,0c-5.372-5.371-12.793-8.693-20.99-8.693C368.632,172.887,358.107,180.325,353.58,190.934z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#302C89"
    },
    points: "93.126,362.657 266.612,393.094 266.612,114.906 93.126,145.343  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302C89"
    },
    d: "M279.106,347c6.485,5.241,14.735,8.385,23.722,8.385c20.864,0,37.778-16.914,37.778-37.778v-90.832 h-61.501L279.106,347L279.106,347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302C89"
    },
    d: "M302.828,212.646c16.577,0,30.016-13.438,30.016-30.016c0-16.577-13.438-30.016-30.016-30.016 c-9.651,0-18.232,4.56-23.722,11.637v36.758C284.597,208.087,293.177,212.646,302.828,212.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#302C89"
    },
    d: "M418.262,246.237H353.03v80.234c6.857,8.07,17.076,13.188,28.482,13.188 c9.981,0,19.545-3.992,26.563-11.087c7.018-7.095,10.905-16.703,10.796-26.681L418.262,246.237z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#302C89"
    },
    cx: 380.9,
    cy: 202.57,
    r: 29.688
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.083,222.896h-25.88v75.613h-15.619v-75.613h-25.88v-15.533h67.378v15.533H214.083z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.f2eee889.svg";
export { ForwardRef as ReactComponent };